import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as ifaSelectProductTypeState from '../employee-detail.reducer';
import * as ifaSelectProductTypeReducer from '../reducers/ifa-select-product-type.reducer';

export const selectIFAProductType = createSelector(
  ifaSelectProductTypeState.getSelectIFAProductTypeState,
  ifaSelectProductTypeReducer.getIfaProductType
);
